
















import Vue from 'vue'
import { MdDialog } from 'vue-material/dist/components'

Vue.use(MdDialog)
export default Vue.extend({
  name: 'ActionDialog',
  props: {
    action: String
  },
  methods: {
    showDialog (): void {
      this.$emit('show-dialog')
    }
  }
})
